import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, ValidationErrors, Validators } from "@angular/forms";
import { CommonService } from "src/app/core-services/common.service";
import { Port } from "src/app/models/Port";
import { Country } from "src/app/models/Country";
import { Result } from "src/app/models/ResultModel";
import { LandingPageSearchModel } from "src/app/models/LandingPageSearchModel";
import { DataParam } from "src/app/Enum/Enum";
import { ToastrService } from "ngx-toastr";
import { openLoginModal } from "src/app/core-services/eventEmitter";
import { Title, Meta, MetaDefinition } from "@angular/platform-browser";
import { VoyagePageData } from "../../../Enum/Enum";
import { Router } from "@angular/router";
@Component({
  selector: "app-voyage-filter-controls",
  templateUrl: "./voyage-filter-controls.component.html",
  styleUrls: ["./voyage-filter-controls.component.scss"],
  providers: [CommonService],
})
export class VoyageFilterControlsComponent implements OnInit {
  @Input() filterType: string = DataParam.VoyageTrackerSearch.toString();
  @Input() title: string;
  @Input() pageTitle: string;//input for dynamic title
  @Input() isFinder: boolean;//input if component called on voyage
  @Input() selectedValues: LandingPageSearchModel;
  @Input() background: string = "water-blue-ocean.png";
  @Output() onSubmit: EventEmitter<string> = new EventEmitter();
  @Input() isOpenSearch = false;
  @Input() isDefaultValues = false;
  sourceCountries: Country[];
  destinationCountries: Country[];
  sourcePort: any[];
  destinationPort: any[];
  rageYears: string;
  landingPageSearch = new LandingPageSearchModel();
  fromPort = null;
  toPort = null;
  openSearchFromPort: string;
  openSearchToPort: string;
  searchRouteBy= "country";
  portForm = this.formBuilder.group({
    fromCountry: ["", Validators.required],
    fromPort: ["", Validators.required],
    toCountry: ["", Validators.required],
    toPort: ["", Validators.required],
    date: ["", Validators.required],
  });

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private toastr: ToastrService,
    private titleService: Title,
    private metaService: Meta,
    private router: Router
  ) { }

  ngOnInit(): void {
    const minDate = new Date();
    this.rageYears =
      minDate.getUTCFullYear() + ":" + (minDate.getUTCFullYear() + 50);
    if (this.selectedValues && this.isDefaultValues) {
      this.getSourceCountry();
      this.getSourceCountryPorts(this.selectedValues.fromCountryId, true);
      this.getDestinationCountryBySourcePort(
        this.selectedValues.fromCountryId,
        this.selectedValues.fromPortIds
      );
      this.getDestinationPort(
        this.selectedValues.toCountryId,
        this.selectedValues.fromPortIds, true
      );
      this.portForm.controls.date.setValue(new Date() as any);
    } else {
      this.portForm.controls.date.setValue(new Date() as any);
      this.getSourceCountry();
    }
    //setting up title and meta in case of finder
    if (this.isFinder || this.pageTitle) {
      this.setTitle();
      this.addTag();
    }
  }

  setSearchBy(value) {
    this.searchRouteBy = value;
  }

  /**
   * to add dynamic tilte for the page only
   */
  setTitle() {
    this.titleService.setTitle(this.pageTitle);
  }
  /**
   * to add dynamic meta content for this page only
   */
  addTag() {
    this.metaService.addTag({
      name: VoyagePageData.MetaName,
      content: VoyagePageData.MetaContent,
    });
  }
  onSearch() {
    if (this.portForm.invalid) {
      const errors = this.getFormValidationErrors();
      if (errors) {
        this.toastr.error(errors);
      }
    } 
    else if (this.isOpenSearch && !this.areOpenSearcAndFormValuesSame()) {
      return false;
    } 
    else if (this.portForm.valid) {
      var data: any = this.portForm.value;
      let date = this.dateConvert(this.portForm.value.date);
      this.landingPageSearch.date = date;
      this.landingPageSearch.toCountryId = data.toCountry.id;
      this.landingPageSearch.toPortIds = data.toPort.map((x) => x.id);
      this.landingPageSearch.fromCountryId = data.fromCountry.id;
      this.landingPageSearch.fromPortIds = data.fromPort.map((x) => x.id);
      this.landingPageSearch.isSearch = true;
      if (this.filterType == DataParam.VoyageTrackerSearch.toString()) {
        localStorage.setItem(
          DataParam.VoyageTrackerSearch.toString(),
          JSON.stringify(this.landingPageSearch)
        );
      } else {
        localStorage.setItem(
          DataParam.LandingPageSearch.toString(),
          JSON.stringify(this.landingPageSearch)
        );
      }

      this.onSubmit.emit();
    }
  }

  onSearchByCountry() {
    const errors = (this.portForm.value.toCountry as any)?.id && (this.portForm.value.fromCountry as any)?.id;
    if (!errors) {
      this.toastr.error("Please select country.");
    }
    else if (this.isOpenSearch && !this.areOpenSearcAndFormValuesSame()) {
      return false;
    } 
    else {
      var data:any = this.portForm.value;
      let date = this.dateConvert(this.portForm.value.date);
      this.landingPageSearch.date = date;
      this.landingPageSearch.toCountryId = data.toCountry.id;
      this.landingPageSearch.fromCountryId = data.fromCountry.id;
      this.landingPageSearch.isSearch = true;
      this.landingPageSearch.isCountrySearch = true;
      if (this.filterType == DataParam.VoyageTrackerSearch.toString()) {
        localStorage.setItem(
          DataParam.VoyageTrackerSearch.toString(),
          JSON.stringify(this.landingPageSearch)
        );
      } else {
        localStorage.setItem(
          DataParam.LandingPageSearch.toString(),
          JSON.stringify(this.landingPageSearch)
        );
      }

      this.onSubmit.emit();
    }
  }

  areOpenSearcAndFormValuesSame() {
    var data:any = this.portForm.value;
    if (
      (this.isOpenSearch && this.isDefaultValues) &&(
        data.fromCountry.id != +this.selectedValues.fromCountryId ||
      data.toCountry.id != +this.selectedValues.toCountryId ||
      data.fromPort.length > 1 || data.toPort.length > 1 ||
      data.fromPort[0].id != +this.selectedValues.fromPortIds[0] ||
      data.toPort[0].id != +this.selectedValues.toPortIds[0])
    ) {
      this.toastr.warning(
        `Please register to use the port-to-port search. It's completely FREE.`
      );
      setTimeout(() => {
        this.router.navigateByUrl('/planselection');
      }, 4000);
      return false;
    }
    return true;
  }

  onSourceCountryChange(event) {
    if (this.searchRouteBy == "port") {
      this.resetSourcePorts();
      this.getSourceCountryPorts(event.value.id);
    } else {
      this.destinationCountries = this.sourceCountries;
    }
  }

  onSourcePortChange(event) {
    let fromCountryId = (this.portForm.value.fromCountry as any)?.id;
    let fromPortIds = event.value.map((x) => x.id);
    if (fromPortIds.length > 0 && fromCountryId) {
      this.getDestinationCountryBySourcePort(fromCountryId, fromPortIds);
    }
    this.resetDesinationCountries();
  }
  onDestinationCountryChange(event) {
    if(this.searchRouteBy!='country'){
    let toCountryId = event.value.id;
    let fromPortIds = (this.portForm.value.fromPort as any).map((x) => x.id);
    if (fromPortIds.length > 0 && toCountryId) {
      this.getDestinationPort(toCountryId, fromPortIds);
    }
    this.resetDestinationPorts();
  }
  }

  private getSourceCountry() {
    this.commonService
      .GetSourceCountries()
      .subscribe((response: Result<Country[]>) => {
        if (response && response.succeeded) {
          this.sourceCountries = response.data;
          if (this.searchRouteBy == "country") {
            this.destinationCountries = this.sourceCountries;
          }
          if (this.selectedValues && this.selectedValues.fromCountryId) {
            for (let element of this.sourceCountries) {
              if (element.id == this.selectedValues.fromCountryId) {
                this.portForm.controls.fromCountry.setValue(element as any);
              }
            }
          }
        }
      });
  }

  private getSourceCountryPorts(countryId: number, isPageLoad = false) {
    this.commonService
      .GetSourceCountryPorts(countryId)
      .subscribe((response: Result<Port[]>) => {
        if (response && response.succeeded) {
          this.sourcePort = response.data;
          if (this.selectedValues && this.selectedValues.fromPortIds) {
            let selectedFromPorts:any = this.sourcePort.filter((x) =>
              this.selectedValues.fromPortIds.includes(x.id.toString())
            );
            if (selectedFromPorts.length <= 5) {
              this.portForm.controls.fromPort.setValue(selectedFromPorts);
              this.fromPort = selectedFromPorts[0];
            }
            if (isPageLoad) {
              this.openSearchFromPort = selectedFromPorts[0].portName;
            }
          }
        }
      });
  }

  private getDestinationCountryBySourcePort(
    countryId: number,
    portIds: number[]
  ) {
    this.commonService
      .GetDestinationCountry(countryId, portIds)
      .subscribe((response: Result<Country[]>) => {
        if (response && response.succeeded) {
          this.destinationCountries = response.data;
          if (this.selectedValues && this.selectedValues.toCountryId) {
            for (let element of this.destinationCountries) {
              if (element.id == this.selectedValues.toCountryId) {
                this.portForm.controls.toCountry.setValue(element as any);
              }
            }
          }
        }
      });
  }

  private getDestinationPort(countryId: number, portIds: number[], isPageLoad = false) {
    this.commonService
      .GetDestinationCountryPorts(countryId, portIds)
      .subscribe((response: Result<Port[]>) => {
        if (response && response.succeeded) {
          this.destinationPort = response.data;
          if (this.selectedValues && this.selectedValues.toPortIds) {
            let selectedToPorts:any = this.destinationPort.filter((x) =>
              this.selectedValues.toPortIds.includes(x.id.toString())
            );
            if (selectedToPorts.length <= 5) {
              this.portForm.controls.toPort.setValue(selectedToPorts);
              this.toPort = selectedToPorts[0];
            }
            if (isPageLoad) {
              this.openSearchToPort = selectedToPorts[0].portName;
            }
          }
        }
      });
  }

  private resetDestinationPorts() {
    this.portForm.controls.toPort.reset();
    this.portForm.controls.toPort.setValue('');
    //this.masterDestinationPorts = [];
  }

  private resetDesinationCountries() {
    this.portForm.controls.toCountry.reset();
    this.portForm.controls.toCountry.setValue('');
    // this.masterSourceCountries = [];
    this.resetDestinationPorts();
  }

  private resetSourcePorts() {
    this.portForm.controls.fromPort.reset();
    this.portForm.controls.fromPort.setValue('');
    //this.masterSourcePorts = [];
    this.resetDesinationCountries();
  }

  dateConvert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  getFormValidationErrors() {
    let errors = "";

    if (this.portForm.controls.fromCountry.status == "INVALID") {
      errors = "Please select origin country.";
    } else if (this.portForm.controls.fromPort.status == "INVALID") {
      errors = "Please select origin ports.";
    } else if (this.portForm.controls.toCountry.status == "INVALID") {
      errors = "Please select destination country.";
    } else if (this.portForm.controls.toPort.status == "INVALID") {
      errors = "Please select destination ports.";
    } else if (this.portForm.controls.date.status == "INVALID") {
      errors = "Please select the date.";
    } else {
      errors = "Something went wrong with validation.";
    }
    return errors;
  }

  register() {
    openLoginModal();
  }
}
